import { promisifyDialog } from '@shared/utils/dialog'
import CinemaSeries from '@remote/components/cinema/CinemaSeries.vue'
import CinemaSourceSetting from '@remote/components/cinema/CinemaSourceSetting.vue'
import PopSelectFile from '@remote/components/PopSelectFile.vue'
import PopMenu from '@remote/components/PopMenu.vue'
import PopDownloadDir from '@remote/components/PopDownloadDir.vue'
import PopCinemaFeedback from '@remote/components/cinema/PopCinemaFeedback.vue'
import PopCinemaModify from '@remote/components/cinema/PopCinemaModify.vue'
import PopCinemaSearch from '@remote/components/cinema/PopCinemaSearch.vue'
import VipPlayTimes from '@remote/components/privilege/VipPlayTimes.vue'
import BtChoicePop from '@remote/components/bt-choice-pop/BtChoicePopHOC.vue'
import LinkChoicePop from '@remote/components/bt-choice-pop/LinkChoicePopHOC.vue'
import FileProcessor from '@remote/components/file-processor/FileProcessorHOC.vue'
import PreviewAlbum from '@remote/components/preview-album/FileProcessorHOC.vue'
import DeviceDetail from '@remote/views/info/device-modal.vue'
import SettingModal from '@remote/views/settings/modal/index.vue'
import Toast from '@remote/components/Toast.vue'
import CinemaDetail from '@remote/components/cinema/CinemaDetail.vue'
import pinia from '@remote/store/pinia-instance'
import DeviceList from '@remote/components/PopDeviceList.vue'
import { store } from '@remote/store'

export const openCinemaSeries = (props: PromisifyDialogProps<typeof CinemaSeries>) => {
  return promisifyDialog(CinemaSeries, props)
}

export const openCinemaSourceSetting = () => {
  return promisifyDialog(CinemaSourceSetting)
}

export const openPopSelectFile = () => {
  return promisifyDialog(PopSelectFile)
}

export const openPopMenu = (props: PromisifyDialogProps<typeof PopMenu>) => {
  return promisifyDialog(PopMenu, props)
}

export const openPopDownloadDir = () => {
  return promisifyDialog(PopDownloadDir)
}

export const openPopCinemaFeedback = (props: PromisifyDialogProps<typeof PopCinemaFeedback>) => {
  return promisifyDialog(PopCinemaFeedback, props)
}

export const openPopCinemaModify = (props: PromisifyDialogProps<typeof PopCinemaFeedback>) => {
  return promisifyDialog(PopCinemaModify, props)
}

export const openPopCinemaSearch = (props: PromisifyDialogProps<typeof PopCinemaSearch>) => {
  return promisifyDialog(PopCinemaSearch, props)
}

export const openVipPlayTimes = (props: PromisifyDialogProps<typeof VipPlayTimes>) => {
  return promisifyDialog(VipPlayTimes, props)
}

export const openBtChoicePop = (props: PromisifyDialogProps<typeof BtChoicePop>) => {
  return promisifyDialog(BtChoicePop, props)
}

export const openLinkChoicePop = (props: PromisifyDialogProps<typeof LinkChoicePop>) => {
  return promisifyDialog(LinkChoicePop, props)
}

export const openFileProcessor = (props: PromisifyDialogProps<typeof FileProcessor>) => {
  return promisifyDialog(FileProcessor, props)
}

export const toast = (props: PromisifyDialogProps<typeof Toast>| string) => {
  return promisifyDialog(Toast, typeof props === 'string' ? {message: props} : props)
}

export const openDeviceViewer = (props: PromisifyDialogProps<typeof DeviceDetail>) => {
  return promisifyDialog(DeviceDetail, props)
}

export const openHeziSettings = (props: PromisifyDialogProps<typeof SettingModal>) => {
  return promisifyDialog(SettingModal, props)
}

export const openPreviewAlbum = (props: PromisifyDialogProps<typeof PreviewAlbum>) => {
  console.log('call openPreviewAlbum', props)
  return promisifyDialog(PreviewAlbum, props)
}

export const openCinemaDetail = (props: PromisifyDialogProps<typeof CinemaDetail>) => {
  return promisifyDialog(CinemaDetail, props, pinia)
}

export const openDeviceList = (props: PromisifyDialogProps<typeof DeviceList>) => {
  return promisifyDialog(DeviceList, props, store)
}